// eslint-disable-next-line import/no-mutable-exports
export let unreportedStatsigInitialisationError: Error | undefined;

export const setUnreportedStatsigInitialisationError = (error: Error) => {
	unreportedStatsigInitialisationError = error;
};
